/* tslint:disable */
/* This file should be ignored by git and the .svg file checked in instead.
 * This file was generated with 'svg-gen'. Manual changes will be lost. */
import React from 'react';
import { createIcon } from '../../createIcon';
export var ExpandIcon = createIcon("ExpandIcon", function (title) {
  var _color = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  return /*#__PURE__*/React.createElement("svg", {
    width: "30",
    height: "30",
    viewBox: "0 0 30 30",
    fill: "none"
  }, /*#__PURE__*/React.createElement("title", null, title), /*#__PURE__*/React.createElement("rect", {
    width: "30",
    height: "30",
    rx: "4",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m13.5 16.499-6 6m15-10.5v-4.5H18m-10.5 10.5v4.5H12m10.5-15-6 6",
    stroke: "#000",
    strokeWidth: "1.5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
}, {});